import { ErrorReporter } from '../errorHandling/ErrorReporter';

export function initWixRecorder(errorReporter?: ErrorReporter) {
  window.addEventListener('wixRecorderReady', async () => {
    try {
      await window.wixRecorder.addLabel('marketing-templates');
    } catch (error) {
      errorReporter && errorReporter.reportError(error);
    }
  });
}
